import { ReactElement } from "react"

import { Control, Controller, FieldValues, Path } from "react-hook-form"

import { StateSelector, StateSelectorProps } from "../selectors"

export interface StateSelectorFormFieldProps<TFieldValues extends FieldValues>
	extends Omit<StateSelectorProps, "value" | "onChange"> {
	control: Control<TFieldValues>
	name: Path<TFieldValues>
	emptyValueFallback?: string | null
}

export const StateSelectorFormField = <TFieldValues extends FieldValues>({
	name,
	control,
	emptyValueFallback = "",
	...rest
}: StateSelectorFormFieldProps<TFieldValues>): ReactElement => {
	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { onBlur, value, onChange }, fieldState: { error } }) => {
				return (
					<StateSelector
						fillContainer
						{...rest}
						onBlur={onBlur}
						value={value != null ? String(value) : emptyValueFallback ?? null}
						onChange={(newValue) => onChange(newValue ?? emptyValueFallback ?? null)}
						error={error?.message}
					/>
				)
			}}
		/>
	)
}
